import {all, fork} from 'redux-saga/effects';

export function* saga() {
    const sagas = [];
    yield all(sagas.map(saga =>
        fork(saga)
    ));


}